import { useEffect, useState } from 'react';

import { useScript } from './useScript';

const QM_SRC = 'https://cdn.quantummetric.com/qscripts/quantum-seaworld.js';

export enum QMEvent {
  AccountTap = 359,
  CartTap = 360,
  RewardsAddToCartError = 444,
}

/**
 * useQuantumMetric loads the Quantum Metric script from a CDN.
 *
 * sendEvent can be used as an escape hatch to manually fire QM events
 * when QM is unable to sniff the events from their side.
 *
 * @return {*}
 */
export const useQuantumMetric = () => {
  const status = useScript(QM_SRC, { shouldPreventLoad: import.meta.env.DEV, defer: true });
  const [eventQueue, setEventQueue] = useState<Array<{ id: QMEvent; msg?: string }>>([]);

  useEffect(() => {
    if (status === 'ready' && eventQueue.length > 0) {
      eventQueue.forEach(({ id, msg }) => {
        window.QuantumMetricAPI?.sendEvent(id, true, msg);
        console.log(`Sent Quantum Metric event: ${id}`);
      });
      setEventQueue([]);
    }
  }, [status, eventQueue]);

  const sendQMEvent = (id: QMEvent, msg?: string) => {
    if (status === 'ready') {
      window.QuantumMetricAPI?.sendEvent(id, true, msg);
      console.log(`Sent Quantum Metric event: ${id}`);
    } else {
      console.warn('Script not ready, queuing Quantum Metric event.');
      setEventQueue((prevQueue) => [...prevQueue, { id, msg }]);
    }
  };

  return {
    status,
    sendQMEvent,
  };
};
